import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/site-theme.css";

// setup firebase configuration
import firebase from "firebase";
// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCmhv9xENLfzyEchmBrxCcd39YonCTA9Fo",
  authDomain: "jerald-pamugas.firebaseapp.com",
  projectId: "jerald-pamugas",
  storageBucket: "jerald-pamugas.appspot.com",
  messagingSenderId: "858115992789",
  appId: "1:858115992789:web:66821948a8efdb6a0d465c",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

createApp(App)
  .use(router)
  .mount("#app");
